module.exports = __webpack_public_path__ + "img/modal-create-organiut.48d060c6.svg";